import React from "react";
import { Link } from "react-router-dom";
import { Disc3 } from "lucide-react";
import { NumberOneShareButton } from "@/components/NumberOneShareButton";
import { ListenButton } from "@/components/ListenButton";

export const LifeInNumberOnes = ({ items, compact = false, className = "" }) => {
  if (!items || items.length === 0) return null;
  return (
    <div data-testid="life-in-number-ones" className={`rounded-2xl border border-ink bg-paper ${compact ? "p-4" : "p-5"} ${className}`}>
      <div className="flex items-center gap-2">
        <Disc3 className="w-4 h-4 text-gold" />
        <p className="text-[11px] font-bold uppercase tracking-[0.15em] text-gold">Your life in UK No.1s</p>
      </div>
      <ul className={`mt-3 ${compact ? "space-y-1.5 max-h-52 overflow-auto pr-1" : "space-y-2"}`}>
        {items.map((m) => (
          <li key={m.age} data-testid={`no1-milestone-${m.age}`} className="flex items-start gap-3 bg-white border border-[#e5e7eb] rounded-xl px-3 py-2">
            <span className="w-9 h-9 shrink-0 rounded-lg bg-ink text-gold flex items-center justify-center text-[12px] font-bold">{m.age === 0 ? "0" : m.age}</span>
            <span className="min-w-0 flex-1">
              <span className="block text-[11px] text-ink-muted">{m.label} · {m.date_label}</span>
              {(m.charts || [m]).map((c) => (
                <span key={c.chart || "uk_singles"} data-testid={`no1-milestone-${m.age}-${c.chart || "uk_singles"}`} className="flex items-center gap-2 mt-1">
                  <span className="shrink-0 w-[68px] text-[9px] font-bold uppercase tracking-wider text-gold">{c.chart_label || "UK Singles"}</span>
                  <span className="min-w-0 flex-1 truncate text-[13px] text-ink"><span className="font-semibold">{c.title}</span> <span className="text-ink-muted">· {c.artist}</span></span>
                  <ListenButton artist={c.artist} title={c.title} testid={`no1-milestone-listen-${m.age}-${c.chart || "uk_singles"}`} />
                  <NumberOneShareButton item={c} testid={`no1-milestone-share-${m.age}-${c.chart || "uk_singles"}`} greeting={m.age === 0 ? `The ${c.chart_label || "UK Singles"} No.1 the day I was born` : `The ${c.chart_label || "UK Singles"} No.1 on my ${m.age === 21 ? "21st" : `${m.age}th`} birthday`} />
                </span>
              ))}
            </span>
          </li>
        ))}
      </ul>
      <Link to="/number-ones" data-testid="life-no1-all-link" className="mt-3 inline-block text-[12px] font-semibold text-gold hover:underline">Every UK No.1 since 1952 →</Link>
    </div>
  );
};
